import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface ICampaignGenerateUseCase {
    execute(
        username: string,
        language: string,
        recaptchaToken?: string,
        apiToken?: { [key: string]: string }
    ): Promise<any>;
}

export class CampaignGenerateUseCase implements ICampaignGenerateUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(
        username: string,
        language: string,
        recaptchaToken?: string,
        apiToken?: { [key: string]: string }
    ): Promise<any> {
        return await this.subscriptionRepository.campaignGenerate(username, language, recaptchaToken, apiToken);
    }
}
